export default __webpack_public_path__ + "static/media/tavi_big@2x.d87742e3.jpg";